import UsersActions from "./users";

const logicArr = [
  ...UsersActions
];

export default logicArr;


